<template>
    <div>
        <div class="sidebar" :class="expanded?'open':'collapsed'">
            
            <nav>
                <ul>
                    <li><a href="javascript:void(0);" class="trigger" :class="currentControl == Controls.ToC?'active':''" @click="LoadControl(Controls.ToC)">
                        <span class="icon"><listIcon/></span><span>Table of contents</span></a></li>
                    <li><a href="javascript:void(0);" class="trigger" :class="currentControl == Controls.Search?'active':''" @click="LoadControl(Controls.Search)">
                        <span class="icon"><searchIcon/></span><span>Search</span></a></li>
                    <li><a href="javascript:void(0);" :class="currentControl == Controls.Filter?'active':''" class="trigger" @click="LoadControl(Controls.Filter)">
                        <span class="icon"><filterIcon/></span><span>Filter</span></a></li>
                    <li><a href="https://www.youtube.com/watch?v=eVLsdbPdTDY" target="_blank">
                        <span class="icon"><QuestionIcon/></span><span>Help</span></a></li>
                    <li><a href="javascript:void(0);" class="toggle" @click="toggle">
                        <span class="icon collapse">
                          <div class="py-2"><LeftChevron/></div>
                        </span><span>Collapse</span></a></li>
                </ul>
                
            </nav>
            
            <div class="pane" :class="showOverLay && expanded?'open':''">                
                <component :is="currentComponent" @close="closeBar" @applyFilter="applyFilter"></component>
            </div>
        </div>       
    </div>
</template>

<script>
import "@/assets/sass/sidebar.scss";
import searchIcon from "@/components/Svg/SearchIcon";
import surveyIcon from "@/components/Svg/SurveyIcon";
import QuestionIcon from "@/components/Svg/Question";
import filterIcon from "@/components/Svg/FilterIcon";
import listIcon from "@/components/Svg/ListIcon";
import LeftChevron from "@/components/Svg/LeftChevron";
import RightChevron from "@/components/Svg/RightChevron";
import search from "@/components/SearchContainer";
import toc from "@/components/TableOfContent";
import refiner from "@/components/FilterControl";
const Controls = Object.freeze({ Search: 1, ToC: 2, Filter: 3 });


export default {
  name: "Sidebar",
   components: {
      searchIcon,
      filterIcon,
      listIcon,
      surveyIcon,
      QuestionIcon,
      LeftChevron,
      RightChevron,
      toc,
      search,
      refiner
  },
  data(){
      return{
          expanded: false,
          showOverLay: false,
          currentControl: null,
          Controls
      };
  },
  computed: {
        currentComponent() {
            if (this.currentControl == Controls.Search) return search;
            if (this.currentControl == Controls.ToC) return toc;
            if (this.currentControl == Controls.Filter) return refiner;
        }  
    },
  methods: {
      toggle: function(){          
          this.expanded = !this.expanded;
         // this.$emit("toggle");   
      },
      applyFilter: function(components){          
          this.$emit("applyFilter", components);   
      },
      showSurvey(){
        window.open(process.env.VUE_APP_SURVEY_URL, "_blank", "width=900&height=500&location=no");
      },
      LoadControl: function(indentifier){
          this.showOverLay = true;   
          if(!this.expanded){
              this.expanded = true;
              this.$emit("toggle");               
          } else {
            if(this.$route.fullPath.includes('refined')){
                this.$router.push({ path: `/` });
                this.$emit("reset");
            }
          }          
          this.currentControl = indentifier;       
      },
      closeBar: function(){
        this.showOverLay = false; 
        this.currentControl = null;  
        this.toggle();
        
      }
   },
   watch:{
    '$route.query': function (newvalue) {
        if(this.$route.fullPath.includes('reset')){
            this.$emit("reset");
            this.closeBar();
        }        
      }
   }
};
</script>
